import request from "@/utils/request";

// 获取平台增效数值
export function getAllCount() {
  return request({
    url: "/pt/main/getAllCount",
    method: "get"
  });
}

//注册
export function register(data) {
  return request({
    url: "/pt/user/register",
    method: "post",
    data
  });
}

//获取手机验证码
export function getSmsCode(parameter) {
  return request({
    url: "/pt/user/getSmsCode",
    method: "post",
    params: parameter
  });
}

// 修改密码
export function updatePwd(parameter) {
  return request({
    url: "/pt/user/updatePwd",
    method: "post",
    params: parameter
  });
}

// 平台资讯文件下载
export function downloadFile(tag) {
  return request({
    url: "/common/downloadFile?tag=" + tag,
    method: "get"
  });
}

// 免登陆跳转
export function downTicket(tag) {
  return request({
    url: "/oapi/sign/auth?ticket=" + tag,
    method: "get"
  });
}

/**
 * 根据token获取个人信息
 * @returns {*} 个人信息
 */
export function userInfoByToken() {
  return request({
    url: '/system/user/userinfo_by_token',
    method: 'get'
  })
}

/**
 * 更新用户信息
 * @param data 参数
 * @returns {*}
 */
export function updateUserInfo(data) {
  return request({
    url: '/system/user/update/user_name',
    method: 'post',
    data: data
  })
}

/**
 * 修改用户手机号码
 * @param params 参数
 * @returns {*}
 */
export function updatePhoneNumber(params) {
  return request({
    url: '/pt/user/update/phonenumber',
    method: 'post',
    params: params
  })
}

/**
 * 校验验证码
 * @param params 参数
 */
export function checkSmsCode(params) {
  return request({
    url: '/pt/user/check/smscode',
    method: 'get',
    params: params
  })
}

export function forgetSmsCode(params) {
  return request({
    url: '/pt/user/forget/smscode',
    method: 'get',
    params: params
  })
}

//登陆方法
export function login(index, status, forceOpen) {
  if (status) {
    var usertoken = localStorage.getItem("usertoken");
    if (usertoken || forceOpen == true) {
      let url_param = (usertoken == null ? "" : ("?token=" + usertoken));
      switch (index) {
        // 餐厨垃圾智能收运系统
        case 1:
          window.open(
            "http://sy.eiiplat.com/#/dataKanban" + url_param
          );
          break;
        // 厕改
        case 2:
          // window.open(`#`);
          break;
        // 智能管控系统
        case 3:
          window.open("http://is.eiiplat.com/#/login" + url_param);
          break;
        // 智能设计系统
        case 7:
          url_param = (url_param == "" ? "/#/homePage" : ("/#/login" + url_param))
          window.open(
            "http://design.eiiplat.com" + url_param
          );
          break;
        // 智能供应系统
        case 8:
          url_param = (url_param == "" ? "/#/home" : ("/#/login" + url_param))
          window.open("http://gy.eiiplat.com" + url_param);
          break;
        // 施工管理系统
        case 9:
          window.open("http://sg.eiiplat.com/#/login" + url_param);
          break;
        // 机制管理系统
        case 10:
          if (localStorage.userType === "404") {
            window.open(
              "http://pt.eiiplat.com/user/login" + url_param
            );
          }
          break;
        // 财务资讯系统
        case 11:
          //url_param=(url_param==""?"":(url_param+"&userId="+localStorage.userId))
          window.open(
            `http://cwzx.eiiplat.com/financialAdvice/index?userId=${localStorage.userId}&token=${localStorage.usertoken}`
          );
          break;
        //okr系统
        case 12:
          window.open(
            `http://okr.eiiplat.com?userId=${localStorage.userId}&token=${localStorage.usertoken}`
          );
          break;
        //供应链金融系统
        case 13:
          url_param = (url_param == "" ? "" : (url_param + "&userId=" + localStorage.userId))
          window.open(
            "http://scmfin.eiiplat.com/#/home" + url_param
          );
          break;
        default:
          break;
      }
    } else {
      alert("请先登录系统！如未注册，请先注册用户~");
    }
  } else {
    switch (index) {
      //天健智慧环保平台
      case 5:
        window.open("http://www.zhgtjiot.cn/login");
        break;
      // 智慧环卫云平台
      case 4:
        window.open("http://hq.huanwei.tidecloud.com/");
        break;
      // 升禾环境云
      case 12:
        // window.open("http://www.zgshgs.com/");
        break;
      // 生活垃圾焚烧管理平台
      case 6:
        window.open("http://218.94.105.110:8183/wdmis/login");
        break;
      // 餐厨运营管理系统、
      case 13:
        window.open("http://solidwastesale.movingdt.com/index");
        break;
      // 渗滤液运营管理系统
      case 14:
        window.open("http://leachatesale.movingdt.com/login");
        break;
      case 15:
        window.open("http://183.66.214.218:29089");
        break;
      case 16:
        window.open("http://183.66.214.218:29176/login?redirect=%2Findex");
        break;
      case 17:
        window.open("http://183.66.214.218/");
        break;
      case 18:
        window.open("http://183.66.214.218:29098");
        break;
      case 19:
        window.open("http://183.66.214.218:29236");
        break;
      default:
        break;
    }
  }
}

const count = {
  getAllCount,
  register,
  getSmsCode,
  forgetSmsCode,
  updatePwd,
  downloadFile,
  userInfoByToken,
  updateUserInfo,
  updatePhoneNumber,
  checkSmsCode
};
export default count;



// WEBPACK FOOTER //
// ./src/api/home.js